import { Section, SectionParagraph, SectionTitle } from '@/components/shared/Content';
import JoinCTA from '@/components/shared/JoinCTA';
import { Flex, font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import parse from 'html-react-parser';
import type React from 'react';
import styled from 'styled-components';

const ClaimsDifferentInner = styled(Flex)`
  max-width: 880px;
`;

const ClaimsDifferentParagraph = styled(SectionParagraph)`
  margin-top: 20px;
  white-space: normal !important;
  max-width: 840px;
`;

const CheckOurPrices = styled(JoinCTA)`
  &&& {
    margin-top: 80px;

    ${MEDIA_QUERIES.tabletAndDesktop`
            ${font('main', {
              fontSize: '1.4rem',
              lineHeight: '6rem',
              fontWeight: 700,
            })};
            padding: 0 20px;
            width: 226px;
        `}
  }
`;
export interface DifferentProps {
  title: string;
  subtitle: string;
  cta: {
    label: string;
    url?: string;
    eventName?: string;
  };
}

export const Different: React.FC<DifferentProps> = ({ title, subtitle, cta }) => {
  return (
    <Section as="section">
      <ClaimsDifferentInner flexDirection="column" alignItems="center" py={[80, 80, 100]} pt={[80, 0]} px={20}>
        <SectionTitle tabIndex={0}>{title}</SectionTitle>
        <ClaimsDifferentParagraph id="different-subtitle">{parse(subtitle)}</ClaimsDifferentParagraph>

        <CheckOurPrices
          customUrl={cta.url}
          flavor="primary"
          size="big"
          aria-label={cta.label}
          data-event={cta.eventName ?? 'claims_page.join_button_clicked'}
          glowing
        >
          {cta.label}
        </CheckOurPrices>
      </ClaimsDifferentInner>
    </Section>
  );
};
